export function alphabetOnly(event:any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode >= 65 && charCode <= 90) || (charCode >= 97 && charCode <= 122)) {
      return true;
    }
    return false;
}

export function alphabetWithSpaces(event:any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode >= 65 && charCode <= 90) || (charCode >= 97 && charCode <= 122) || charCode == 32) {
      return true;
    }
    return false;
}

export function alphaNumericOnly(event:any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode >= 48 && charCode <= 57) || ((charCode >= 65 && charCode <= 90) || (charCode >= 97 && charCode <= 122))) {
      return true;
    }
    return false;
}

export function alphaNumericWithSpaces(event:any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode >= 48 && charCode <= 57) || ((charCode >= 65 && charCode <= 90) || (charCode >= 97 && charCode <= 122)  || charCode == 32)) {
      return true;
    }
    return false;
}

export function numericOnly(event:any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode >= 48 && charCode <= 57)) {
      return true;
    }
    return false;
} 

export function alphaNumericWithSpacesDot(event:any): boolean {
const charCode = (event.which) ? event.which : event.keyCode;
if ((charCode >= 48 && charCode <= 57) || ((charCode >= 65 && charCode <= 90) || (charCode >= 97 && charCode <= 122) || charCode == 32  || charCode == 46)) {
  return true;
}
return false;
}

export function alphaNumericHyphenSlash(event:any): boolean {
  const charCode = (event.which) ? event.which : event.keyCode;
  if ((charCode >= 48 && charCode <= 57) || ((charCode >= 65 && charCode <= 90) || (charCode >= 97 && charCode <= 122))
     || charCode === 45 || charCode === 47) {
    return true;
  }
  return false;
}

export function alphaNumericWithSpacesSlaceHyphenComma(event:any): boolean {
  const charCode = (event.which) ? event.which : event.keyCode;
  if ((charCode >= 48 && charCode <= 57) || ((charCode >= 65 && charCode <= 90) || (charCode >= 97 && charCode <= 122) || charCode == 32 || charCode == 44 || charCode == 45 || charCode == 47)) {
    return true;
  }
  return false;
}

export function getGrowthRatio(oldValue:string,newValue:string): number {
  let ratio:number = 0;
  let oldFloat = parseFloat(oldValue);
  let newFloat = parseFloat(newValue);
  if(oldFloat > 0 && newFloat > 0){
    ratio = parseFloat((((newFloat-oldFloat)/ oldFloat) * 100).toFixed(2));
  }
  else if(oldFloat == 0)
  {
    if(newFloat == 0){
      ratio = 0;
    }
    else
    {
      ratio = 99999;
    }
  }
  return ratio;
}

export interface KeyValueItem {
  key: string;
  value: string;
}

export function convertToKeyValuePairs(
  data: any,
  notAvailableText: string = 'Not Available'
): KeyValueItem[] {

  if (!data || typeof data !== 'object') {
    return [];
  }

  const result: KeyValueItem[] = [];

  Object.keys(data).forEach((prop) => {
    let value = data[prop];

    // Handle null / undefined / empty
    if (value === null || value === undefined || value === '') {
      value = notAvailableText;
    }
    // Normalize booleans
    else if (typeof value === 'boolean') {
      value = value ? 'Yes' : 'No';
    }
    // Normalize Yes/No strings
    else if (typeof value === 'string') {
      const lower = value.toLowerCase();
      if (lower === 'true') value = 'Yes';
      else if (lower === 'false') value = 'No';
    }
    // Objects (skip or stringify)
    else if (typeof value === 'object') {
      value = '[Object]';
    }

    result.push({
      key: formatKey(prop),
      value: String(value)
    });
  });

  return result;
}

function formatKey(key: string): string {
  return key
    // handle camelCase
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    // handle snake_case
    .replace(/_/g, ' ')
    // capitalize words
    .replace(/\b\w/g, char => char.toUpperCase())
    .trim();
}

export function isJsonString(str: string): boolean {
  try {
    JSON.parse(str);
    return true;
  } catch (e) {
    return false;
  }
}